import { BasicClient } from '@/utils/httpClient'

export default class Folders {
  client: BasicClient
  constructor() {
    this.client = new BasicClient()
  }

  getFoldersAvailable(params) {
    return this.client.exec(`/folders/available`, 'POST', params)
  }

  getDocumentTypeAvailable(params) {
    return this.client.exec(`/folders/documentTypes/available`, 'POST', params)
  }

  getFoldersUser(iduser) {
    return this.client.exec(`/v2/admin-mod/userfolder/` + iduser, 'GET')
  }

  addFoldersUser(params) {
    return this.client.exec(`/v2/admin-mod/userfolder`, 'POST', params)
  }

  deleteFoldersUser(iduser) {
    return this.client.exec(`/v2/admin-mod/userfolder/` + iduser, 'DELETE')
  }

  getFoldersSettingsAvailable(params = {}) {
    return this.client.exec(`/v2/folders/available`, 'GET', params)
  }

  getSubFoldersAvailableForId(params = {id: '', pagination: {}}) {
    return this.client.exec(
      '/v2/subfolders/available?id_carpeta=' + params.id,
      'GET', { pagination: params.pagination }
    )
  }

  updateSubFolder(subFolder) {
    return this.client.exec(
      `/v2/subfolder/update/${subFolder.id}`,
      'PUT',
      subFolder
    )
  }

  deleteSubFolder(subFolder) {
    return this.client.exec(`/v2/subfolder/remove/${subFolder.id}`, 'DELETE')
  }

  createSubFolder(subFolder) {
    return this.client.exec(`/v2/subfolder/create`, 'POST', subFolder, true)
  }

  getTemplateSubFolders(subFolder) {
    let idSubFolder = subFolder ? `?id=${subFolder.id}` : ''
    return this.client.exec(`/v2/templates/available${idSubFolder}`, 'GET')
  }

  getApplicationParser() {
    return this.client.exec('/applications/parser', 'GET')
  }

  getFoldersGroup(params = false) {
    return this.client.exec(
      '/v2/admin-mod/documents/documentsTypesUserFilters',
      'GET', 
      params
    )
  }

  publishSingleDocument(params) {
    return this.client.exec(
      '/v2/admin-mod/publish/document/single',
      'POST',
      params,
      true
    )
  }

  publishGenericDocument(params) {
    return this.client.exec(
      '/v2/admin-mod/publish/documents/generic',
      'POST',
      params,
      true
    )
  }

  getFoldersAndEforms() {
    return this.client.exec('/v2/admin-mod/documents/filtersType', 'GET')
  }

  getLockEnabledFolders(id) {
    const url = id ? `/v2/folders/blocker/${id}` : '/v2/folders/blocker'
    return this.client.exec(url, 'GET')
  }

  createFolder(params) {
    return this.client.exec('/v2/folder', 'POST', params)
  }

  updateFolder(id, params) {
    return this.client.exec(`/v2/folder/${id}`, 'PUT', params)
  }

  deleteFolder(id, params) {
    return this.client.exec(`/v2/folder/${id}`, 'DELETE', params)
  }

  getConfigurationFolder(id) {
    return this.client.exec(`/v2/folders/${id}`, 'GET')
  }

  getDocumentType(id) {
    return this.client.exec(`/documents/typesbyfolder/${id}`, 'GET')
  }

  getConfigurationSubFolder(id) {
    return this.client.exec(`/v2/subfolders/${id}`, 'GET')
  }

  getConfigurationSubFolderSignature(id){
    return this.client.exec(`/v2/subfolders/${id}/signatures`,'GET')
  }

  getPDFInfo(file) {
    return this.client.exec(`/v2/signaturePosition/pdfInfo`, 'POST', { file }, true)
  }

  setNewPDFFile(id, params) {
    return this.client.exec(`/v2/subfolders/${id}`, 'POST', params, true)
  }

  editDocumentInformation (id, params) {
    return this.client.exec(`/v2/admin-mod/documents/${id}`, 'PATCH', params)
  }

  cancelDocumentInformation (id, params) {
    return this.client.exec(`/v2/admin-mod/documents/cancel/${id}`, 'PATCH', params)
  }

  addObservation (params) {
    return this.client.exec(`/v2/documentobservation/question`, 'POST', params)
  }

  deleteObservation (params) {
    return this.client.delete(`/v2/documentobservation/question`, params)
  }
}
